export default __webpack_public_path__ + "static/media/art_museum.023c5cfd.svg";